import { Component, Input, Output, EventEmitter, ViewChild, TemplateRef, ViewChildren, QueryList, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ItemsSection } from 'src/app/shared/models/data/documentTemplate';
import { EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { getTubesAndPipesSection } from '../generic-items-section/default-tubes-and-pipes';
import _ from 'lodash';

@Component({
  selector: 'app-technical-description-section',
  templateUrl: './technical-description-section.component.html',
  styleUrls: ['./technical-description-section.component.scss']
})
export class TechnicalDescriptionSectionComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() saleOfficeCountry!: string;
  @Input() itemsSections: ItemsSection[] = [];
  @Input() uncategorizedItems: EnquiryHeaderItem[] = [];
  @Input() reset!: (sectionName: string) => void;

  @Output() sectionChange = new EventEmitter<{ updatedSectionData: ItemsSection, originalSection: ItemsSection }>();
  @Output() addItem = new EventEmitter<{ section: ItemsSection, item: EnquiryHeaderItem }>();
  @Output() removeItem = new EventEmitter<{ section: ItemsSection, item: EnquiryHeaderItem }>();

  @ViewChild('promptTemplate') promptTemplate!: TemplateRef<any>;
  @ViewChild('confirmTemplate') confirmTemplate!: TemplateRef<any>;
  @ViewChildren('itemsSectionRef') itemsSectionsRefs!: QueryList<any>;

  newSectionName = '';
  newSectionIsValid = false;
  isReady = false;

  constructor(
    private teiasoftToaster: TeiasoftToasterService,
    private translate: TranslateService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.isReady = true;
    }, 0);
  }

  onSectionChange(updatedSectionData: ItemsSection, originalSection: ItemsSection) {
    this.sectionChange.emit({ updatedSectionData, originalSection });
  }

  onAddItem(section: ItemsSection, item: EnquiryHeaderItem) {
    this.addItem.emit({ section, item });
  }

  onRemoveItem(section: ItemsSection, item: EnquiryHeaderItem) {
    this.removeItem.emit({ section, item });
  }

  addNewSection(): void {
    const dialogRef: MatDialogRef<any> = this.dialog.open(this.promptTemplate, {
      data: {} // No data is passed here
    });


    dialogRef.afterClosed().subscribe((sectionName: string) => {
      if (sectionName && sectionName.trim() !== '') {
        this.createNewSection(sectionName.trim());
      }
    });
  }

  async createNewSection(sectionName: string): Promise<void> {
    const tubeAndPipesSectionDefault = _.cloneDeepWith(await getTubesAndPipesSection(this.saleOfficeCountry), (value) => {
      if (typeof value === 'function') {
        return value;
      }
    });

    const newSection: ItemsSection = {
      sectionName: sectionName,
      technicalDescription: {
        isModified: false,
        value: '',
        selectedValues: {},
      },
      fields: tubeAndPipesSectionDefault.fields,
      freeText: '',
      items: [],
      showTotalLength: false,
      showTotalPrice: false,
      showTotalWeight: false
    };
    this.itemsSections.push(newSection);
  }

  removeSection(index: number): void {
    const dialogRef: MatDialogRef<any> = this.dialog.open(this.confirmTemplate, {
      data: {} // No data is passed here
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const itemsToRemove = [...this.itemsSections[index].items];
        itemsToRemove.forEach(item => {
          this.removeItem.emit({ section: this.itemsSections[index], item });
        });
        this.itemsSections.splice(index, 1);
      }
    });
  }

  onInputSectionName($event: any) {
    this.newSectionName = $event;

    // Check if the section name already exists
    const sectionExists = this.itemsSections.some(
      section => section.sectionName.toLowerCase() === this.newSectionName.toLowerCase()
    );

    this.newSectionIsValid = !sectionExists;

  }

  onPanelOpened(index: number): void {
    const itemsSection = this.itemsSectionsRefs.toArray()[index];
    if (itemsSection && itemsSection.applySelectedValues) {
      // Call the applySelectedValues method in the child component
      itemsSection.applySelectedValues();
    }
  }
}
